import { render } from "./ExtremeNetworks.vue?vue&type=template&id=d7c9dbec"
import script from "./ExtremeNetworks.vue?vue&type=script&lang=ts"
export * from "./ExtremeNetworks.vue?vue&type=script&lang=ts"
script.render = render

export default script